export const PLAN_ALLOWED_CHANNELS = {
  sandbox: ['chatmail']
}